import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';

import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import PageLayout from 'blocks/Layouts/page-layout';
import TermsAndConditions from 'blocks/terms-and-conditions';

import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import StaticPageContent, {
  type StaticPageContentProps,
} from 'data/staticPageContent';
import data from 'data/termsAndConditions.json';

import type { IGenericPage } from 'types/interfaces';

import termsAndConditionsImage from 'assets/terms-and-conditions/header-image.webp';
import type { TermsAndConditionsType } from 'types/types';

interface TermsAndConditionsProps extends IGenericPage {
  pageContent: StaticPageContentProps;
  termsAndConditions: TermsAndConditionsType[];
}

const TermsAndConditionsPage: NextPage<TermsAndConditionsProps> = ({
  globalLayoutProps,
  pageContent,
  termsAndConditions,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PageLayout {...pageContent} image={termsAndConditionsImage}>
        <TermsAndConditions termsAndConditions={termsAndConditions} />
      </PageLayout>
    </GlobalLayout>
  );
};

export default TermsAndConditionsPage;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.TERMS_AND_CONDITIONS,
  });
  const pageContent = StaticPageContent[navigationPaths.TERMS_AND_CONDITIONS];
  const termsAndConditions = data as TermsAndConditionsType[];

  return {
    props: {
      ...genericPageProps,
      pageContent,
      termsAndConditions,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
